import { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Navigate, Routes } from "react-router-dom";

import EUCRMConference from "../routes/eucrm-routes";
import Convergence2023Footer from "../components/footer/convergence-2023-footer";
import SvgIcons from "../components/re-usable/icons/svg-icons";
import { RootState, useAppDispatch } from "../redux/store";
import { useSelector } from "react-redux";
import { retrieveNotification } from "../redux/slice/notification-slice";
import LoadingComp from "../components/re-usable/loading/loading";
import EUCRMConferenceHeader from "../components/header/eucrm-header";
import EUCRMConferenceLayoutStyleComponent from "./components/eucrm-layout-style.component";
import Footer from "../components/footer/footer";

const EUCRMConferenceLayout = () => {
  const dispatch = useAppDispatch()

  const { notificationData, notificationLoading, notificationError } = useSelector((state: RootState) => state.notification)

  useEffect(() => {
    dispatch(retrieveNotification())
  }, [dispatch])

  const notification = notificationData.map((notification) => {
    return notification.notificationMenuData.map((item) => {
      return item.rapsUpdates;
    })
  })

  return (
    <>
      <EUCRMConferenceLayoutStyleComponent />
      <div>
        <EUCRMConferenceHeader />
        <Suspense fallback={<LoadingComp />}>
          <Routes>
            {EUCRMConference.map((route, index) => {
              return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
            })}
          </Routes>
        </Suspense>
        <Footer />
        {/*<Convergence2023Footer footerClass="bg-primary text-light" />
        <SvgIcons />*/}
      </div >
    </>
  );

};

export default EUCRMConferenceLayout;
